import React from 'react';
import { Typography, Box } from '@mui/material';
import StyledBox, {
  StyledLightBulbHint,
} from 'views/information-module/InsuranceView/components/CoveringOffRoad/CoveringOffRoad.styles';
import { useTranslation } from 'next-i18next';
import Typography500 from 'views/common/components/UI/Typography500';
import { OffRoadDamageWaiverTable } from 'views/common/components';

const CoveringOffRoad = () => {
  const { t } = useTranslation('fe_er_insurance_page');
  return (
    <StyledBox>
      <Typography500 component="h3" variant="h3">
        {t('fe_er_insurance_page:covering_off_road_header')}
      </Typography500>

      <Typography
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:coverage_off_road_desc1'),
        }}
      />

      <Typography
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:coverage_off_road_desc2'),
        }}
      />

      <Box className="COTableContainer">
        <OffRoadDamageWaiverTable />
      </Box>

      <Typography
        component="p"
        variant="body1"
        className="CRTableCaption"
        dangerouslySetInnerHTML={{
          __html: t(
            'fe_er_insurance_page:coverage_off_road_damage_waiver_note',
          ),
        }}
      />

      <StyledLightBulbHint>
        <Typography
          variant="h6"
          dangerouslySetInnerHTML={{
            __html: t(
              'fe_er_insurance_page:damage_waiver_insurance_off_road_note',
            ),
          }}
        />
      </StyledLightBulbHint>
    </StyledBox>
  );
};

export { CoveringOffRoad };
